import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import styles from './DescriptionTab.module.css';
import { normalizeImageUrl } from '@/utils/image';

interface ConsultationBannerProps {
    text?: string;
    buttonText?: string;
    buttonLink?: string;
}

const ConsultationBanner: React.FC<ConsultationBannerProps> = ({
    text = "Book your 30 minutes free consultation with our research experts",
    buttonText = "Contact Us",
    buttonLink = "/contact-us"
}) => {
    return (
        <div className={styles.consultationBanner}>
            <div className={styles.bannerLeft}>
                <div className={styles.expertAvatarWrapper}>
                    <Image
                        src={normalizeImageUrl('site_images/representative-image.png')}
                        alt="Research Expert"
                        width={60}
                        height={60}
                        className={styles.expertAvatar}
                    />
                </div>
                <div className={styles.bannerTextWrapper}>
                    <p className={styles.bannerText}>
                        {text}
                    </p>
                </div>
            </div>
            <Link href={buttonLink}>
                <button className={styles.contactUsButton}>
                    {buttonText}
                </button>
            </Link>
        </div>
    );
};

export default ConsultationBanner;
